'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.processString = exports.grey = undefined;

var _split2 = require('lodash/fp/split');

var _split3 = _interopRequireDefault(_split2);

var _reduce2 = require('lodash/fp/reduce');

var _reduce3 = _interopRequireDefault(_reduce2);

var _propertyOf2 = require('lodash/fp/propertyOf');

var _propertyOf3 = _interopRequireDefault(_propertyOf2);

var _mergeAll2 = require('lodash/fp/mergeAll');

var _mergeAll3 = _interopRequireDefault(_mergeAll2);

var _merge2 = require('lodash/fp/merge');

var _merge3 = _interopRequireDefault(_merge2);

var _map2 = require('lodash/fp/map');

var _map3 = _interopRequireDefault(_map2);

var _isPlainObject2 = require('lodash/fp/isPlainObject');

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

var _isString2 = require('lodash/fp/isString');

var _isString3 = _interopRequireDefault(_isString2);

var _flow2 = require('lodash/fp/flow');

var _flow3 = _interopRequireDefault(_flow2);

var _defaultTo2 = require('lodash/fp/defaultTo');

var _defaultTo3 = _interopRequireDefault(_defaultTo2);

exports.boxShadow = boxShadow;

var _tinycolor = require('tinycolor2');

var _tinycolor2 = _interopRequireDefault(_tinycolor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var grey = exports.grey = (0, _tinycolor2.default)({ r: 220, g: 220, b: 220 });

function boxShadow() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : grey;

  return { boxShadow: '0 0 .2em 0 ' + color.setAlpha(0.2).toRgbString() };
}

var processString = exports.processString = function processString(styleObj) {
  return (0, _flow3.default)((0, _split3.default)(' '), (0, _map3.default)((0, _flow3.default)((0, _propertyOf3.default)(styleObj), (0, _defaultTo3.default)({}))), _mergeAll3.default);
};
// styleBuilder with default styles defined above partially applied.
// Example: css('static top0 p0 m3') == { position: 'static', top: 0, padding: 0, margin: '3rem' }
var reducer = exports.reducer = function reducer(styleObj) {
  return function () {
    var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var item = arguments[1];

    if (!item) return res;
    if ((0, _isPlainObject3.default)(item)) return (0, _merge3.default)(res, item);
    if ((0, _isString3.default)(item)) return (0, _merge3.default)(res, processString(styleObj)(item));
    return res;
  };
};
// Default export is a function that converts className string above.

exports.default = function (styleObj) {
  return (0, _flow3.default)(Array, (0, _reduce3.default)(reducer(styleObj), undefined));
};


//////////////////
// WEBPACK FOOTER
// ./~/cape-style/lib/styleBuilder.js
// module id = 862
// module chunks = 0